import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class ProjectExpertizeDetailBase {

//#region projectExpertizeDetailsId Prop
        @prop()
        projectExpertizeDetailsId : number;
//#endregion projectExpertizeDetailsId Prop


//#region projectId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        projectId : number;
//#endregion projectId Prop


//#region projectExpertizeId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        projectExpertizeId : number;
//#endregion projectExpertizeId Prop


//#region projectExpertizeSubCategoryId Prop
        @range({minimumNumber:1,maximumNumber:2147483647})
        @required()
        projectExpertizeSubCategoryId : number;
//#endregion projectExpertizeSubCategoryId Prop







}